/*
Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
import { useMemo } from 'react';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { getCorrectionByDiff } from '@ink-ai/portal/common/utils/document.util';

interface ViewDiffProps {
  originalText?: string;
  generatedText?: string;
}

export const ViewDiff = ({ originalText, generatedText }: ViewDiffProps) => {
  const differences = useMemo(() => {
    if (originalText && generatedText) {
      return getCorrectionByDiff(originalText, generatedText);
    } else {
      return [];
    }
  }, [originalText, generatedText]);
  return (
    <Typography gutterBottom>
      {differences.map((diff, idx) => {
        if (diff.removed) {
          return (
            <Box
              key={idx}
              component="span"
              sx={{
                color: 'error.main',
                textDecoration: 'line-through',
              }}
            >
              {diff.value}
            </Box>
          );
        } else if (diff.added) {
          return (
            <Box key={idx} component="span" sx={{ color: 'success.main' }}>
              {diff.value}
            </Box>
          );
        } else {
          return <span key={idx}>{diff.value}</span>;
        }
      })}
    </Typography>
  );
};

export default ViewDiff;
